import { Column } from '@datum-group/isogd-openapi/lib';
import { FilterInputTypes } from './FilterInput';

export function getColumnFilterType({
  data_type,
  references,
}: Column): FilterInputTypes {
  if (data_type === 'VarChar') {
    return 'string';
  } else if (
    ['SmallInt', 'Integer', 'BigInt', 'Decimal', 'Real', 'Float'].includes(
      data_type,
    )
  ) {
    if (references) {
      return 'table-record-reference';
    } else {
      return 'number';
    }
  } else if (data_type === 'Boolean') {
    return 'boolean';
  } else if (data_type === 'Date') {
    return 'date';
  } else if (data_type === 'Time') {
    return 'time';
  } else if (data_type === 'TimeStamp') {
    return 'datetime';
  } else {
    return 'other';
  }
}
